<template>
  <b-modal :title="modalTitle" size="lg" class="modal-light" v-model="showModal" @ok="submit">
    <b-row v-if="showError">
      <b-col sm='12'>
        <b-alert v-for="(error, index) in errors" :key="index" show variant="warning">{{error}}</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm='4'>Email:</b-col>
      <b-col sm='8'>
        <input type='text' placeholder='Enter email' v-model='user.email'>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm='4'>First name:</b-col>
      <b-col sm='8'>
        <input type='text' placeholder='Enter first name' v-model='user.first_name'>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm='4'>Last name:</b-col>
      <b-col sm='8'>
        <input type='text' placeholder='Enter last name' v-model='user.last_name'>
      </b-col>
    </b-row>
    <br>
    <template v-if="this.mode === 'create'">
      <b-row>
        <b-col sm='4'>Password</b-col>
        <b-col sm='8'>
          <input :type='passwordInputType' placeholder='Enter password' v-model='user.password'>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm='4'>Verify Password</b-col>
        <b-col sm='8'>
          <input :type='passwordInputType' placeholder='Enter password' v-model='password_verify'>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm='4'>Show Passwords</b-col>
        <b-col sm='8'>
          <b-check v-model='show_passwords' />
        </b-col>
      </b-row>
    </template>
    <br>
    <clients-select ref="clientsSelect" />
    <br>
    <client-groups-select ref='groupsSelect' />
    <br>
    <b-row>
      <b-col sm='4'>
        User sees only dashboards that have been shared with them?
      </b-col>
      <b-col sm='6'><b-check v-model='user.show_only_shared_dashboards' /></b-col>
    </b-row>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import ClientsSelect from '@/views/base/ClientsSelect'
import ClientGroupsSelect from '@/views/base/ClientGroupsSelect'
export default {
  name: 'UserModal',
  components: {
    vSelect,
    ClientsSelect,
    ClientGroupsSelect
  },
  data () {
    return {
      showModal: false,
      userId: null,
      mode: null,
      errors: [],
      showError: false,
      user: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        show_only_shared_dashboards: false
      },
      password_verify: null,
      show_passwords: false
    }
  },

  mounted () {
    this.$eventBus.$on('editUserModal', (user, clients, client_groups) => this.initEditMode(user, clients, client_groups))
    this.$eventBus.$on('newUserModal', () => this.initCreateMode())
  },

  beforeDestroy(){
    this.$eventBus.$off('editUserModal')
    this.$eventBus.$off('newUserModal')
  },

  methods: {
    displayErrors (errors) {
      this.errors = errors
      this.showError = true
    },

    initCreateMode () {
      this.reset()
      this.mode = 'create'
      this.showModal = true
    },

    initEditMode (user, clients, client_groups) {
      this.reset()
      this.mode = 'edit'
      this.user = user
      this.$refs.clientsSelect.clients = clients
      this.$refs.groupsSelect.clientGroups = client_groups.filter(group => group.id != 'my_adworks_clients')
      this.showModal = true
    },

    checkParams () {
      var passwordValidation = this.user.password.match(/^(?=.*[a-z]|\d|[#$^+=!*()@%&])\S{8,14}$/gi) ? true : false
      var passwordsMatch = this.user.password === this.password_verify
      if ((this.user.password !== null && passwordValidation && passwordsMatch) && this.user.first_name !== null && this.user.last_name !== null && (this.user.email !== null && this.user.email.indexOf('@') > -1)) {
        this.createUser()
      } else if (this.user.password === null || this.user.password.length < 8 || this.user.password.length > 14) {
        alert('Passwords must be 8-14 characters long')
      } else if (!passwordsMatch){
        alert('Passwords must match')
      } else if (this.user.first_name === null) {
        alert('User must include first name')
      } else if (this.user.last_name === null) {
        alert('User must include last name')
      } else if (this.user.email === null || this.user.email.indexOf('@') < 0) {
        alert('User must have valid email address')
      } else {
        if (passwordValidation && this.user.first_name !== null && this.user.last_name !== null && (this.user.email !== null && this.user.email.indexOf('@') < 0)) {
          this.createUser()
        } else {
          alert('User unable to be created')
        }
      }
    },

    submit (e) {
      e.preventDefault()
      if (this.mode === 'create') {
        this.checkParams()
      } else if (this.mode === 'edit') {
        if (!this.user.first_name || !this.user.last_name || !this.user.email) {
          alert("User must have first name, last name, and email")
        } else {
          this.updateUser()
        }
      }
    },

    createUser () {
      this.showModal = false
      this.$http.post('/create_client_user', {user: this.params})
        .then(function(response){
          this.$parent.users.push(response.data.user)
        }.bind(this))
    },

    updateUser () {
      this.$http.patch('/update_client_user/' + this.user.id, this.params)
        .then(function(response){
          this.showModal = false
          this.$parent.user = (response.data.user)
        }.bind(this))
      .catch(function (error) {
        this.displayErrors(error.response.data.errors)
      }.bind(this))
    },

    reset () {
      this.errors = []
      this.showError = false
      this.user.first_name = null
      this.user.last_name = null
      this.user.email = null
      this.user.password = null
      this.user.show_only_shared_dashboards = false
      this.password_verify = null
      this.show_passwords = false
      this.$refs.clientsSelect.clients = []
      this.$refs.groupsSelect.clientGroups = []
    }
  },

  computed: {
    modalTitle () {
      if (this.mode == 'edit') {
        return 'Edit client user'
      } else {
        return 'Create client user'
      }
    },
    passwordInputType () {
      if (this.show_passwords) {
        return 'text'
      } else {
        return 'password'
      }
    },
    params () {
      var params = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        client_ids: this.$refs.clientsSelect.clients.map(function(client) {
          return client.id
        }),
        client_group_ids: this.$refs.groupsSelect.clientGroups.map(function(group) {
          return group.id
        }),
        show_only_shared_dashboards: this.user.show_only_shared_dashboards
      }
      if (this.user.password !== null) {
        params.password = this.user.password
      }
      return params
    }
  }
}
</script>
